import React, { useMemo } from "react";
import { UI_DATE_FORMAT } from "../../../../consts";
import dayjs from "dayjs";
import { InputNumber, Table } from "antd";

const HarvestTable = ({
  dateHeaders,
  dataSource,
  onCellValueChange,
  siteMetadata,
}) => {
  const harvestColumns = useMemo(() => {
    const harvestCriteria =
      siteMetadata?.forecast?.RIPENESS_CRITERIA_METRIC_NAME ||
      "Harvest Criteria";
    const dayCols = dateHeaders.map((dh, idx) => ({
      title: dayjs(dh).format(UI_DATE_FORMAT),
      dataIndex: `day${idx}`,
      key: `day${idx}`,
      render: (value, record) => {
        if (record.isParent) {
          return value;
        }
        return (
          <InputNumber
            rootClassName="w-25"
            min={record.metricKey === harvestCriteria ? record.minValue : 0}
            max={
              record.metricKey === harvestCriteria ? record.maxValue : undefined
            }
            value={value}
            onChange={(newVal) =>
              onCellValueChange(record, `day${idx}`, newVal)
            }
          />
        );
      },
    }));

    return [
      {
        title: "Subsite",
        dataIndex: "subsite",
        key: "subsite",
        render: (text, record) =>
          record.isParent ? (
            <div className="font-semibold text-primaryBlue text-nowrap mr-16">
              {text}
            </div>
          ) : (
            text
          ),
      },
      {
        title: "Harvest Details",
        dataIndex: "detail",
        key: "detail",
      },
      ...dayCols,
    ];
  }, [dateHeaders, onCellValueChange]);

  const harvestRowClassName = (record) => {
    let classes = "border-b border-gray-300";
    if (record.isParent) {
      classes += " border-t-2 border-gray-400 pt-2 ";
    }
    return classes;
  };

  return (
    <Table
      columns={harvestColumns}
      dataSource={dataSource}
      bordered={false}
      pagination={false}
      rowClassName={harvestRowClassName}
      expandable={{ defaultExpandAllRows: true }}
      className="my-custom-table-class"
    />
  );
};

export default HarvestTable;
